/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { AIRLINES } from "constants/appConstants.js";
import { useUserContext } from "contexts/userContext.js";

/* Components */
import UCGrid from "../../ucgrid";
import SafetyNoTrips from "../../safetyNoTrips";
import { TRAVELER_DETAILS_ROUTE } from "../../../constants/routes";
import { useLocaleContext } from "../../../contexts/localeContext";
import { useIsResponsive } from "../../../hooks/useIsResponsive";
import { HotelTypeColumns } from "../providerBasedColumns/hotelType/index";
import { AirTypeColumns } from "../providerBasedColumns/airType/index";

/* Styles */
import styles from "./styles.js"
import { breakpoints } from "../../../constants/breakpoints";

const columnMapping = {
  [AIRLINES.AA]: AirTypeColumns,
  [AIRLINES.AS]: AirTypeColumns,
  [AIRLINES.CHOICE]: HotelTypeColumns,
};

//used to differenciate between grids so that custom column names can be applied in the text files
const gridNameMapping = {
  [AIRLINES.AA]: "safetyGrid",
  [AIRLINES.AS]: "safetyGrid",
  [AIRLINES.CHOICE]: "safetyGridChoice",
};

const SafetyGrid = (props) => {
  const {gridOptions, setGridOptions, safetyResponse, displayBookingInfoModal, displayInviteGuestModal, showSkeleton} = props;
  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;
  const [selectedRow, setSelectedRow] = useState(null);
  const globalLocale = useLocaleContext();

  const isMobile = useIsResponsive([breakpoints.lg]);

  const customColumns = (columnMapping[providerCode] || AirTypeColumns)({
    globalLocale,
    displayBookingInfoModal,
    displayInviteGuestModal,
  });

  const gridName = gridNameMapping[providerCode] || "safetyGrid";

  return (
    <div className={classes.grid}>
      <UCGrid
        gridName={ gridName }
        data={ safetyResponse?.results }
        columns={ safetyResponse?.columns }
        actions={ safetyResponse?.actions }
        handlePageChange={(page) => setGridOptions({
          ...gridOptions,
          page
        })}
        spinner="safetyGridSpinner"
        showSkeleton={showSkeleton}
        setSelectedRow={setSelectedRow}
        noDataComponent={ <SafetyNoTrips /> }
        showHeader={true}
        persistTableHead={!isMobile}
        customColumns={customColumns}
        columnCustomWidth={{
          avatarName: "340px",
          flightInfo: "300px",
          bookingInfo: "330px",
          traveller: "340px",
          departureStatus: "120px",
          flightNumberGroup: "120px",
          startDate: "140px",
          mainStatus: "150px"
        }}
        columnCustomProps={[
          {
            columnName: "departureStatus",
            width: "100px",
            allowOverflow: true,
            style: {
              display: 'flex',
              justifyContent: 'start'
            }
          },
          {
            columnName: "flightNumberGroup",
            allowOverflow: true,
          },
          {
            columnName: "startDate",
            allowOverflow: true,
          }
      ]}
        showChevronIcon={true}
        avatarNameLink={row => TRAVELER_DETAILS_ROUTE.replace(":travelerId", row.userEntityID)}
        onRowClick={displayBookingInfoModal}
        defaultSort={safetyResponse?.defaultSort}
        handleSort={(column, sortDirection) =>
          setGridOptions({
            ...gridOptions,
            sortby: column.id,
            sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
          })
        }
      />
    </div>
  )
}

export default SafetyGrid;